import blacklogo from "../images/blacklogo.svg"
import photo1 from "../images/NFT Pic.png"
import { Link } from "react-router-dom";

export default function Marketplace() {
    return (

        <div className="relative bg-background pt-10 h-98">
            <div className="relative h-82 bg-blue">
                <div className="grid grid-cols-12">
                    <div className="items-start col-span-3">
                        <img className="h-92 pr-20 items-start w-72" src={blacklogo}></img>
                    </div>
                    <div className="flex items-start flex-col col-span-6">
                        <p className="mx-10 mr-10 mt-5 text-base not-italic font-normal font-text leading-6">One hour prior to the commencement of each event, the marketplace will be closed. This guarantees that all NFTs listed on the platform are authenticated and exclusively owned by the buyer.</p>
                        <p className="mx-10 mt-8 order-first text-5xl not-italic font-bold leading-10 font-title text-white sm:text-5xl">Explore our Secure Ticket Resale Marketplace </p>
                        <Link
                            to="/marketplace"
                            className="rounded-lg ml-12 mt-4 bg-background px-5 py-3 text-sm font-semibold text-white shadow-sm"
                        >
                            View Marketplace
                        </Link>
                    </div>
                    <div className="mr-5 col-span-3 gap-y-4">
                        <img className="h-70% my-2 shadow-black shadow-xl" src={photo1}></img>
                    </div>
                </div>


            </div>
        </div>

    )
}